import React from 'react'
import {Tooltip, Typography } from '@mui/material';

const TotalInvoicesCard = ({themescolors, totalCost = 0, currency = "SAR", translate, bgImage,title,hideCurrency=false }) => {
    const textStyle = {
        fontSize: "22px",
        fontWeight: 600,
        color:themescolors?.textColor|| "#fff",
    };

    const nFormatter = (num, digits) => {
        const si = [
            { value: 1E9, symbol: "B" },
            { value: 1E6, symbol: "M" },
            { value: 1E3, symbol: "K" }
        ];
        for (let i = 0; i < si.length; i++) {
            if (num >= si[i].value) {
                return (num / si[i].value).toFixed(digits) + si[i].symbol;
            }
        }
        return num.toString();
    };

    return (
        <div
            style={{
                width: "100%",
                minWidth: "204px",
          color:themescolors?.textColor|| "#fff",
                minHeight: "100px",
                backgroundImage: `url(${bgImage})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",           // or "contain", or "100% 100%"
                backgroundPosition: "center",      // ensures it's centered
                padding: "12px 0 18px 14px",
                borderRadius: "12px",
                boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px"
            }}
        >

            <p
                style={{
                    width: "100%",
                        color:themescolors?.textColor|| "#fff",

                    fontWeight: "600",
                    fontSize: "14px",
                }}
            >
               {translate ? translate(title) : title}
            </p>

            <div
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginTop: "14px",
                }}
            >
                <Tooltip
                    title={
                        <Typography style={{ fontSize: "14px" }}>
                            {totalCost.toLocaleString()}
                        </Typography>
                    }
                    placement="bottom-start"
                    enterDelay={300}
                    classes={{ tooltip: "customTooltip" }}
                >
                    <span style={textStyle}>
                        {totalCost ? nFormatter(totalCost, 2) : 0}
                    </span>
                </Tooltip>
                {
                    !hideCurrency&&
                        <span style={{color:themescolors?.textColor|| "#fff", marginLeft: "10px" }}>
                    {currency}
                </span>
                }
            
            </div>
        </div>
    );
};

export default TotalInvoicesCard